import { render } from "./BranchDepartmentsTable.vue?vue&type=template&id=4d38c5ab&scoped=true"
import script from "./BranchDepartmentsTable.vue?vue&type=script&lang=js"
export * from "./BranchDepartmentsTable.vue?vue&type=script&lang=js"

import "./BranchDepartmentsTable.vue?vue&type=style&index=0&id=4d38c5ab&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d38c5ab"]])

export default __exports__